import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { SERVER } from "@/data/content";

export const CopyIp = ({ className = "", testId = "copy-ip-button" }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SERVER.ip);
      setCopied(true);
      toast.success("Sikeresen másolva!", { description: SERVER.ip });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("A másolás nem sikerült");
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      data-testid={testId}
      aria-label="Szerver IP másolása"
      className={`group inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.03] backdrop-blur-md pl-4 pr-2 py-2 font-mono text-xs sm:text-sm text-white/80 transition-colors duration-300 hover:border-[rgba(94,177,255,0.5)] hover:text-white ${className}`}
    >
      <span className="live-dot h-2 w-2 rounded-full bg-[var(--glow)]" />
      <span data-testid="server-ip-text">{SERVER.ip}</span>
      <span className="grid h-7 w-7 place-items-center rounded-full bg-white/5 transition-colors duration-300 group-hover:bg-[rgba(94,177,255,0.18)]">
        {copied ? <Check size={14} className="text-[var(--glow)]" /> : <Copy size={14} />}
      </span>
    </button>
  );
};
